import React, { useState } from 'react';
import axios from 'axios';
import { useParams, useNavigate, Link as RouterLink } from 'react-router-dom';
import {
  Box, Card, CardContent, TextField, Button, Typography, Alert,
  Stack, InputAdornment, IconButton, Link, CircularProgress,
} from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

function ResetPassword() {
  const { token } = useParams();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [feedback, setFeedback] = useState(null); // { type, text }
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFeedback(null);

    if (password !== confirmPassword) {
      setFeedback({ type: 'error', text: 'Şifreler eşleşmiyor. Tekrar deneyin.' });
      return;
    }
    if (password.length < 6) {
      setFeedback({ type: 'error', text: 'Şifre en az 6 karakter olmalı.' });
      return;
    }

    setLoading(true);
    try {
      const res = await axios.post(
        `https://portal.peaksoftcon.com:8081/resetPassword/${token}`,
        { password },
      );
      setFeedback({ type: 'success', text: res.data?.message || 'Şifre güncellendi.' });
      setTimeout(() => navigate('/login'), 2500);
    } catch (err) {
      setFeedback({ type: 'error', text: 'Bir hata oluştu. Lütfen tekrar deneyin.' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: (t) =>
          t.palette.mode === 'dark'
            ? 'linear-gradient(135deg, #0B1220 0%, #1E3A8A 100%)'
            : 'linear-gradient(135deg, #1E3A8A 0%, #3B5BC9 100%)',
        p: 2,
      }}
    >
      <Card sx={{ width: '100%', maxWidth: 420, boxShadow: '0 20px 50px rgba(0,0,0,0.25)' }}>
        <CardContent sx={{ p: { xs: 3, sm: 4 } }}>
          <Stack alignItems="center" spacing={1.5} sx={{ mb: 3 }}>
            <Box
              component="img"
              src="/img/Peak_Logo_Kobalt.png"
              alt="Peak"
              sx={{ width: 96, height: 'auto' }}
            />
            <Typography variant="h5" sx={{ fontWeight: 700 }}>Yeni Şifre</Typography>
            <Typography variant="body2" color="text.secondary" textAlign="center">
              Yeni şifreni belirle ve tekrar gir.
            </Typography>
          </Stack>

          <form onSubmit={handleSubmit}>
            <Stack spacing={2}>
              <TextField
                label="Yeni Şifre"
                type={showPassword ? 'text' : 'password'}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                fullWidth
                required
                autoComplete="new-password"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <LockIcon fontSize="small" />
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => setShowPassword((s) => !s)}
                        edge="end"
                        size="small"
                      >
                        {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              <TextField
                label="Yeni Şifre (Tekrar)"
                type={showPassword ? 'text' : 'password'}
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                fullWidth
                required
                autoComplete="new-password"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <LockIcon fontSize="small" />
                    </InputAdornment>
                  ),
                }}
              />
              {feedback && <Alert severity={feedback.type}>{feedback.text}</Alert>}
              <Button
                type="submit"
                variant="contained"
                size="large"
                fullWidth
                disabled={loading}
                sx={{ py: 1.25 }}
              >
                {loading ? <CircularProgress size={22} color="inherit" /> : 'Şifreyi Güncelle'}
              </Button>
            </Stack>
          </form>

          <Box sx={{ textAlign: 'center', mt: 2.5 }}>
            <Link component={RouterLink} to="/login" underline="hover">
              Giriş sayfasına dön
            </Link>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
}

export default ResetPassword;
